import React from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';

import { ReactComponent as ManualDocumentIcon } from '../../images/icons/manual-document.svg';
import { getDocumentExtension } from '../../utils/PDP/getProductDocuments';
import styles from './ProductManualDocuments.module.scss';

const ProductManualDocuments = ({ productInfo, containerClassName, linkClassName, iconClassName }) => {
  const intl = useIntl();

  const rawProductDocuments = (Array.isArray(productInfo?.manuals) && productInfo.manuals) || [];
  const documents = rawProductDocuments
    .map((document) => {
      if (!document || typeof document !== 'object') {
        return null;
      }

      const href = document.local_url;
      if (!href) {
        return null;
      }

      const name = document.description;
      const extension = getDocumentExtension(document, href);

      return {
        ...document,
        href,
        name,
        extension,
      };
    })
    .filter(Boolean);

  if (!documents.length) {
    return null;
  }

  return (
    <div className={classNames(styles.manualDocuments, containerClassName)}>
      {documents.map((document, index) => {
        const fallbackName = intl.formatMessage(
          {
            id: 'productDetailMarketplace.downloadManual',
            defaultMessage: 'Download Manual #{number}',
          },
          { number: index + 1 }
        );

        const documentName = document.name || fallbackName;
        const documentType = document.extension || 'PDF';
        const displayLabel = intl.formatMessage(
          {
            id: 'product.downloadManual',
            defaultMessage: 'Download {documentName} ({documentType})',
          },
          {
            documentName,
            documentType,
          }
        );

        return (
          <a
            key={`${document.id || document.href || documentName}-${index}`}
            href={document.href}
            target="_blank"
            rel="noopener noreferrer"
            className={classNames(styles.manualDocumentsLink, linkClassName)}
            title={displayLabel}
          >
            <ManualDocumentIcon aria-hidden="true" className={classNames(styles.manualDocumentsIcon, iconClassName)} />
            <span>{displayLabel}</span>
          </a>
        );
      })}
    </div>
  );
};

export default ProductManualDocuments;
